import request from '@/utils/request'

export function queryContract(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract/queryContract',
      method: 'get',
      params
    })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
  })
}